export default __webpack_public_path__ + "static/media/soda_lake.0dc4f968.jpg";